import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import PasswordInput from 'components/PasswordInput';
import eventifyLogo from 'assets/eventify-logo.png';
import styles from './Login.module.css';
import { EMAIL_REGEX } from 'utils/email';


export default function Login() {
  const [form,    setForm]    = useState({ email: '', password: '' });
  const [error,   setError]   = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  // Mensaje post-cambio de contraseña
  const successMsg = location.state?.message || null;
  // D8: motivo de un cierre de sesión forzado (cuenta desactivada), una sola vez.
  // Se lee al iniciar y se borra en un efecto (no en el inicializador: en
  // desarrollo React lo ejecuta dos veces y la segunda ya no lo encontraría).
  const [avisoSesion] = useState(() => {
    try { return sessionStorage.getItem('eventify_aviso_login'); } catch (_) { return null; }
  });
  useEffect(() => {
    try { sessionStorage.removeItem('eventify_aviso_login'); } catch (_) {}
  }, []);

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    // noValidate en el <form>: estas revisiones reemplazan el globo del navegador.
    if (!form.email.trim())                return setError('Ingresa tu correo electrónico');
    if (!EMAIL_REGEX.test(form.email.trim())) return setError('El correo no es válido');
    if (!form.password)                    return setError('Ingresa tu contraseña');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      // Si el usuario debe cambiar contraseña → redirigir a /change-password
      if (user.must_change_password) {
        navigate('/change-password', { replace: true });
        return;
      }
      navigate('/dashboard');
    } catch (err) {
      const msg = err.response?.data?.message || 'Error al iniciar sesión';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className={styles.logoCaja}>
            <img src={eventifyLogo} alt="EVENTIFY" className={`auth-logo-img ${styles.logoImg}`} />
          </div>
          <p>Gestión inteligente de asambleas</p>
        </div>

        {/* Mensaje de éxito post-cambio de contraseña */}
        {avisoSesion && !error && (
          <div className={`alert alert-danger ${styles.aviso}`}>
            <i className={`fas fa-circle-exclamation ${styles.iconoAviso}`} />{avisoSesion}
          </div>
        )}
        {successMsg && (
          <div className={`alert alert-success ${styles.aviso}`}>
            <i className={`fas fa-check-circle ${styles.iconoAviso}`} />{successMsg}
          </div>
        )}

        {error && (
          <div className="alert alert-danger">
            <i className="fas fa-circle-exclamation" /> {error}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label className="form-label">Correo electrónico</label>
            <input type="email" name="email" className="form-control"
              placeholder="tu@correo.com" value={form.email} maxLength={255}
              onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <PasswordInput name="password"
              placeholder="••••••••" value={form.password}
              onChange={handleChange} autoComplete="current-password" required />
          </div>
          <button type="submit" className={`btn btn-primary w-full ${styles.botonEntrar}`}
            disabled={loading}>
            {loading
              ? <><div className={`spinner ${styles.spinnerEntrando}`} /> Entrando...</>
              : 'Iniciar sesión'}
          </button>
        </form>

        <p className="text-center text-muted mt-4">
          ¿No tienes cuenta? <Link to="/register">Regístrate</Link>
        </p>
      </div>
    </div>
  );
}